export class FormArrayValidator {
  static validate(formArray): {[key: string]: any} {
    const selectedCheckboxs = formArray.controls.filter(form => form.value);
    return selectedCheckboxs.length ? null : { required: true };
  }
};
